import * as types from './mutations_types'

export const setPackages = (context, items) => context.commit(types.SET, items)

export const savePackage = (context, item) => context.commit(types.SAVE, item)

export const destroyPackage = (context, id) => context.commit(types.DESTROY, id)

export const packageProductsAmountUpdate = (context, item) => context.commit(types.PRODUCTS_AMOUNT_UPDATE, item)



// WEBPACK FOOTER //
// ./src/modules/parameters/packages/store/actions.js